<template>
	<div class="navigate">
		<div><a href="index.html"><img src="../../assets/ssjt/img/logo.png"></a></div>
		<div class="menus">
			<div>
				<div class="hidden-sm-and-up"><a href="index.html">尚时<br>首页</a></div>
				<div class="hidden-xs-only"><a href="index.html">尚时首页</a></div>
				<div class="hidden-xs-only">Group Home</div>
			</div>
			<div>
				<div class="hidden-sm-and-up"><a href="about.html">尚时<br>介绍</a></div>
				<div class="hidden-xs-only"><a href="about.html">尚时介绍</a></div>
				<div class="hidden-xs-only">Introduction</div>
			</div>
			<div>
				<div class="hidden-sm-and-up"><a class="menu_develop" href="develop.html">发展<br>历程</a></div>
				<div class="hidden-xs-only"><a class="menu_develop" href="develop.html">发展历程</a></div>
				<div class="hidden-xs-only menu_development">Development</div>
			</div>
			<div>
				<div class="hidden-sm-and-up"><a href="contact.html">联系<br>我们</a></div>
				<div class="hidden-xs-only"><a href="contact.html">联系我们</a></div>
				<div class="hidden-xs-only">Contact Us</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Navigate"
}
</script>

<style scoped>
	@media (max-width: 767px){
		.navigate{ height: 60px; margin: auto; padding: 15px 10px 0 20px; color: #75878a; display: flex; justify-content: space-between; }
		.navigate img{ width: 90px; height: 45px; }
		.menus{ padding: 7px 18px 0 20px; font-size: 13px; text-align: center; width: 200px; display: flex; justify-content: space-between; }
		.menus a{ font-weight: bold; color: #75878a; text-decoration: none; transition: all 0.15s linear; }
		.menus a:hover{ color: #ee833b; }
		.menu_develop{ color: #ee833b !important; }
	}
	@media (min-width: 768px){
		.navigate{ width: 1080px; height: 92px; margin: auto; padding-top: 15px; color: #75878a; display: flex; justify-content: space-between; }
		.menus{ padding-top: 20px; font-size: 14px; text-align: center; width: 400px; display: flex; justify-content: space-between; }
		.menus a{ font-weight: bold; color: #75878a; text-decoration: none; transition: all 0.15s linear; }
		.menus a:hover{ color: #ee833b; }
		.menu_develop{ color: #ee833b !important; font-size: 16px; }
		.menu_development{ font-size: 12px; }
	}
</style>